import { render, staticRenderFns } from "./BaseLoadingSpinner.vue?vue&type=template&id=1d405376&"
import script from "./BaseLoadingSpinner.vue?vue&type=script&lang=js&"
export * from "./BaseLoadingSpinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports